import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { 
    FaPhone, FaArrowLeft, FaCheckCircle, FaBuilding, 
    FaCar, FaFileAlt, FaHandHoldingHeart, FaMoon, FaQuoteLeft, FaQuoteRight
} from 'react-icons/fa';
import { useAyuntamiento } from '../context/AyuntamientoContext';

const BACKEND_URL = '';

const getIconForService = (name) => {
    const n = name.toLowerCase();
    if (n.includes('24h') || n.includes('atención')) return <FaMoon />;
    if (n.includes('traslado') || n.includes('recogida')) return <FaCar />;
    if (n.includes('flor') || n.includes('corona')) return <FaCheckCircle />;
    if (n.includes('tanatorio') || n.includes('sala')) return <FaBuilding />;
    if (n.includes('gestión') || n.includes('admin')) return <FaFileAlt />;
    return <FaHandHoldingHeart />;
};

function PerfilFuneraria() {
    const { slug, funerariaSlug } = useParams();
    const { configAyto, cargarAyuntamiento } = useAyuntamiento();

    const [empresa, setEmpresa] = useState(null);
    const [homenajes, setHomenajes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [servicioAbierto, setServicioAbierto] = useState(null);
    // Definimos el color Oro para reutilizarlo
    

    useEffect(() => {
    const cargarTodo = async () => {
        try {
            setLoading(true);

            // 1. Cargamos el perfil de la funeraria (Apuntamos al JSON de configuración del municipio)
            // Normalmente la info de la funeraria de la demo está en el mismo config de Tarazona
            const resEmpresa = await axios.get(`/api/public/config/${slug}/index.json`);
            
            // Si en tu JSON los datos de la empresa están en una propiedad específica, úsala
            // Si no, usamos el objeto completo por ahora para la demo
            setEmpresa(resEmpresa.data.funeraria_detalle || resEmpresa.data);

            // 2. Cargamos el ayuntamiento para colores y logos
            if (slug) await cargarAyuntamiento(slug);

            // 3. Cargamos los difuntos asociados (Usamos el archivo general de difuntos)
            const resHomenajes = await axios.get('/api/v1/difuntos/index.json');
            
            // Para la demo, podemos mostrar todos los difuntos o filtrar los que tengan esa funeraria
            const todos = Array.isArray(resHomenajes.data) ? resHomenajes.data : [];
            setHomenajes(todos);

        } catch (error) {
            console.error("❌ Error en Perfil Funeraria Local:", error);
        } finally {
            setLoading(false);
        }
    };

    if (funerariaSlug) cargarTodo();
}, [funerariaSlug, slug]);

    if (loading) return <div style={{ padding: '100px', textAlign: 'center' }}>⌛ Cargando portal de memoria...</div>;
    if (!empresa) return <div style={{ padding: '100px', textAlign: 'center' }}><h2>❌ Perfil no encontrado</h2></div>;

    // 🎨 SINCRONIZACIÓN DE COLORES CORPORATIVOS (Fase Final)

const colorPrimarioRaw = empresa?.color_primario || '#1a2537';
const colorMarca = colorPrimarioRaw.startsWith('#')
  ? colorPrimarioRaw
  : `#${colorPrimarioRaw}`;

const colorSecundarioRaw = empresa?.color_secundario || '#B8A066';
const colorOro = colorSecundarioRaw.startsWith('#')
  ? colorSecundarioRaw
  : `#${colorSecundarioRaw}`;

const estetica = empresa?.configuracion_estetica || {};
const servicios = empresa?.servicios_json || [];

    return (
        <div className="App-Container-Funeraria" style={{ minHeight: '100vh', backgroundColor: '#f4f1ea', fontFamily: "'Playfair Display', serif" }}>
            
            {/* 1️⃣ HEADER XL: DISEÑO PREMIUM Y TEXTOS LEGIBLES */}
            <header style={{ 
                backgroundColor: colorMarca, 
                color: 'white', 
                padding: '30px 60px', // ⬆️ Más espacio vertical para que respiren los textos
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                boxShadow: '0 10px 30px rgba(0,0,0,0.4)', 
                zIndex: 10,
                borderBottom: '1px solid rgba(255,255,255,0.1)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
                    {/* Logo Circular más imponente */}
                    <div style={{ 
                        width: '100px', height: '100px', borderRadius: '50%', 
                        backgroundColor: 'white', padding: '10px', 
                        display: 'flex', alignItems: 'center', justifyContent: 'center', 
                        overflow: 'hidden', border: '4px solid rgba(255,255,255,0.3)', 
                        boxShadow: '0 4px 15px rgba(0,0,0,0.3)' 
                    }}>
                        <img src={`${BACKEND_URL}${empresa.logo_path}`} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} alt="Logo" />
                    </div>

                    <div>
                        {/* ⬆️ Nombre de la funeraria mucho más grande y potente */}
                        <h1 style={{ 
                            margin: 0, 
                            fontSize: '2.5em', 
                            letterSpacing: '2px', 
                            textTransform: 'uppercase', 
                            fontWeight: '900',
                            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                            lineHeight: '1.1'
                        }}>
                            {empresa.nombre_visible}
                        </h1>
                        
                        {/* ⬆️ Slogan más legible */}
                        <p style={{ 
                            margin: '8px 0 0 0', 
                            fontSize: '1.3em', 
                            opacity: 0.95, 
                            fontStyle: 'italic',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                           <FaQuoteLeft style={{fontSize:'0.6em', opacity:0.5}} /> {estetica.slogan}<FaQuoteRight style={{fontSize:'0.6em', opacity:0.5}} />
                        </p>

                        {/* ⬆️ Texto oficial municipal mejorado */}
                        <p style={{ 
                            margin: '10px 0 0 0', 
                            fontSize: '0.95em', 
                            opacity: 0.7, 
                            fontWeight: 'bold', 
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            Sede autorizada por el Ayuntamiento de {configAyto?.nombre || slug?.toUpperCase()}
                        </p>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '35px' }}>
                    {/* ⬆️ Bloque de teléfono más robusto */}
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ 
                            backgroundColor: 'rgba(184, 160, 102, 0.15)', 
                            border: '2px solid #B8A066', 
                            padding: '12px 30px', 
                            borderRadius: '40px', 
                            display: 'inline-flex', 
                            alignItems: 'center', 
                            gap: '15px'
                        }}>
                            <FaPhone style={{ color: '#B8A066', fontSize: '1.2em' }} />
                            <span style={{ fontWeight: '900', color: '#B8A066', fontSize: '1.6em', letterSpacing: '1px' }}>
                                {estetica.telefono}
                            </span>
                        </div>
                        <p style={{ margin: '8px 5px 0 0', fontSize: '0.85em', opacity: 0.6, fontWeight: 'bold' }}>
                            ATENCIÓN PERMANENTE 24H
                        </p>
                    </div>

                    <Link to={`/${slug}`} style={{ 
                        color: 'white', 
                        textDecoration: 'none', 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '10px', 
                        fontWeight: 'bold', 
                        fontSize: '1em', 
                        opacity: 0.8,
                        padding: '10px',
                        borderBottom: '2px solid transparent',
                        transition: '0.3s'
                    }} 
                    onMouseOver={(e) => e.target.style.borderBottom = '2px solid white'}
                    onMouseOut={(e) => e.target.style.borderBottom = '2px solid transparent'}
                    >
                        <FaArrowLeft /> VOLVER
                    </Link>
                </div>
            </header>
            {/* 💉 BOTÓN DE CONTACTO REDISEÑADO (Más estrecho y elegante) */}
<div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
    <button 
        onClick={() => {
            const mensajeWA = `Hola, he visto su perfil en el portal del Cementerio de ${configAyto?.nombre}. Necesito información sobre sus servicios.`;
            if (estetica.telefono) {
                window.open(`https://wa.me/${estetica.telefono.replace(/\s+/g, '')}?text=${encodeURIComponent(mensajeWA)}`, '_blank');
            } else {
                alert("Por favor, utilice el teléfono de asistencia 24h.");
            }
        }}
        style={{ 
            width: '50%', // 💉 ANCHO REDUCIDO: De 100% a 50%
            padding: '12px 20px', 
            backgroundColor: colorMarca, 
            color: 'white', 
            border: 'none', 
            borderRadius: '30px', // 💉 Bordes más redondeados (Estilo Píldora)
            fontWeight: 'bold', 
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            transition: 'all 0.3s ease',
            fontSize: '0.85em',
            letterSpacing: '1px',
            textTransform: 'uppercase'
        }}
        onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 15px rgba(0,0,0,0.2)';
        }}
        onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        }}
    >
        SOLICITAR INFORMACIÓN
    </button>
</div>


            {/* 2️⃣ HERO SECTION (CONEXIÓN REAL A BASE DE DATOS) */}
            <div style={{ width: '100%', padding: '20px 0', display: 'flex', justifyContent: 'center' }}>
                <div className="Hero-Container" style={{
                    position: 'relative', width: '96%', maxWidth: '1300px', height: '450px', 
                    borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.2)' 
                }}>
                    {empresa?.portada_url ? (
    <img 
        /* 💉 Ahora sí, la ruta será completa y real */
        src={`${BACKEND_URL}${empresa.portada_url}?t=${Date.now()}`} 
        style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
        alt="Portada" 
    />
) : (
    <div style={{ width: '100%', height: '100%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#999' }}>Cargando imagen...</p>
    </div>
)}


                    {/* Mantengo tu degradado original para que el texto o el diseño luzca igual */}
                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to bottom, transparent, rgba(0,0,0,0.3))' }}></div>
                </div>
            </div>

            {/* 3️⃣ CONTENIDO */}
            <div className="Main-Grid-Funeraria" style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '50px', padding: '0 40px' }}>
                
               {/* SERVICIOS */}
<div style={{ backgroundColor: 'rgba(255,255,255,0.4)', padding: '30px', borderRadius: '15px' }}>
    <h3 style={{ borderBottom: `2px solid ${colorOro}`, color: colorOro, paddingBottom: '10px', marginBottom: '25px', letterSpacing: '1px' }}>
        NUESTROS SERVICIOS
    </h3>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
        {servicios.map((s, i) => (
            <div 
                key={i} 
                /* 💉 ACCIÓN DE CLIC INTEGRADA */
                onClick={() => setServicioAbierto(s)}  
                style={{ 
                    backgroundColor: 'white', 
                    padding: '20px', 
                    borderRadius: '12px', 
                    textAlign: 'center', 
                    boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
                    cursor: 'pointer' // 💉 INDICADOR DE MANO
                }}
            >
                <div style={{ fontSize: '1.5em', color: colorMarca, marginBottom: '10px' }}>
                    {getIconForService(typeof s === 'object' ? s.titulo : s)}
                </div>
                <span style={{ fontSize: '0.85em', fontWeight: 'bold', color: '#444' }}>
                    {typeof s === 'object' ? s.titulo.toUpperCase() : s.toUpperCase()}
                </span>
            </div>
        ))}
    </div>
</div>

                {/* 🕯️ COLUMNA DERECHA: ÚLTIMOS HOMENAJES (REJILLA 3x2) */}
<div style={{ backgroundColor: 'white', padding: '25px', borderRadius: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', height: 'fit-content' }}>
    <h3 style={{ color: colorOro, marginBottom: '20px', letterSpacing: '2px', borderBottom: '1px solid #eee', paddingBottom: '10px', fontSize: '1em', fontWeight: '800', textAlign: 'center' }}>
        ÚLTIMOS HOMENAJES
    </h3>

    {/* 💉 CAMBIO CLAVE: gridTemplateColumns pasa de 1fr 1fr a repeat(3, 1fr) */}
    <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(3, 1fr)', 
        gap: '15px' 
    }}>
        {homenajes.slice(0, 6).map(d => (
            <div key={d.id} style={{ 
                aspectRatio: '1/1.2', 
                backgroundColor: 'white', 
                borderRadius: '12px', 
                display: 'flex', 
                flexDirection: 'column', 
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                border: '1px solid #eee'
            }}>
                {/* 🖼️ FOTO (70% del cuadro) */}
                <div style={{ flex: 3, width: '100%', backgroundColor: '#f0f0f0', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {d.foto_social ? (
                        <img 
                            src={`${BACKEND_URL}${d.foto_social}`} 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                            alt={d.nombre} 
                        />
                    ) : (
                        <div style={{ textAlign: 'center', color: '#ccc' }}>
                            <div style={{ fontSize: '2em' }}>👤</div>
                        </div>
                    )}
                </div>

                {/* 📝 TEXTO (30% del cuadro - Centrado) */}
                <div style={{ 
                    flex: 1.2, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    padding: '8px',
                    textAlign: 'center' 
                }}>
                    <strong style={{ 
                        fontSize: '0.75em', // 💉 Un poco más pequeña para que quepa en 3 columnas
                        color: '#1a1a1a', 
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis', 
                        width: '100%' 
                    }}>
                        {d.nombre} {d.apellidos}
                    </strong>
                    <Link to={`/${slug}/difunto/${d.id}#memorial`} style={{ fontSize: '0.6em', color: colorMarca, fontWeight: 'bold', textDecoration: 'none', borderBottom: `1px solid ${colorMarca}`, marginTop: '4px' }}>
                        RENDIR HOMENAJE
                    </Link>
                </div>
            </div>
        ))}
    </div>
</div>
            </div>

            {/* 4️⃣ FOOTER */}
            <footer style={{ backgroundColor: colorMarca, color: 'white', padding: '50px 0', marginTop: '80px', textAlign: 'center' }}>
                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    {/* TELÉFONO EN ORO EN FOOTER */}
                    <div style={{ fontSize: '1.8em', marginBottom: '20px', color: colorOro, fontWeight: 'bold' }}>
                        📞 {estetica.telefono}
                    </div>
                    <p style={{ opacity: 0.6, fontSize: '0.8em' }}>© 2024 {empresa.nombre_visible} - Un espacio de respeto y memoria</p>
                    <Link to={`/${slug}`} style={{ color: 'white', textDecoration: 'none', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                        <FaArrowLeft /> VOLVER AL CEMENTERIO DE {slug?.toUpperCase()}
                    </Link>
                </div>
            </footer>
            {/* 🕯️ VENTANA EMERGENTE: FICHA TÉCNICA DE SERVICIO (SaaS PREMIUM - IDENTIDAD POR ID) */}
{servicioAbierto && (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(8px)' }}>
        <div style={{ 
            backgroundColor: 'white', 
            borderRadius: '20px', 
            maxWidth: '850px', // Diseño Gran Formato
            width: '95%', 
            boxShadow: '0 25px 60px rgba(0,0,0,0.5)', 
            position: 'relative',
            overflow: 'hidden' 
        }}>
            
            {/* Botón de cierre superior */}
            <button 
                onClick={() => setServicioAbierto(null)} 
                style={{ position: 'absolute', top: '20px', right: '20px', border: 'none', background: 'rgba(255,255,255,0.8)', width: '35px', height: '35px', borderRadius: '50%', fontSize: '18px', cursor: 'pointer', color: '#333', zIndex: 10, fontWeight: 'bold' }}
            >✕</button>

            {(() => {
                // 🔍 BUSQUEDA DETERMINISTA POR ID
                // Ya no buscamos por nombre, buscamos por el ID único generado en el Admin
                const sEncontrado = empresa.servicios_json?.find(s => s.id === servicioAbierto.id);
                
                // Mantenemos fallback para compatibilidad con servicios antiguos sin ID (Legacy)
                const tituloFinal = sEncontrado?.titulo || servicioAbierto?.titulo || (typeof servicioAbierto === 'string' ? servicioAbierto : 'Servicio');
                const descripcionFinal = sEncontrado?.descripcion || servicioAbierto?.descripcion;
                const imagenFinal = sEncontrado?.imagen_url || servicioAbierto?.imagen_url;

                return (
                    <div>
                        {/* 🖼️ IMAGEN HERO DEL SERVICIO (FORMATO PANORÁMICO 16:9) */}
                        <div style={{ width: '100%', height: '350px', backgroundColor: '#f0f0f0', overflow: 'hidden', borderBottom: '1px solid #eee' }}>
                            {imagenFinal ? (
                                <img 
                                    src={`${BACKEND_URL}${imagenFinal}`} 
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                                    alt={tituloFinal}
                                />
                            ) : (
                                <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#ccc' }}>
                                    <div style={{ fontSize: '5em' }}>{getIconForService(tituloFinal)}</div>
                                    <p style={{ marginTop: '10px', fontSize: '0.9em', letterSpacing: '1px' }}>IMAGEN EN PREPARACIÓN</p>
                                </div>
                            )}
                        </div>

                        {/* 📝 CONTENIDO DETALLADO */}
                        <div style={{ padding: '40px', textAlign: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', marginBottom: '10px' }}>
                                <div style={{ fontSize: '2em', color: colorMarca }}>{getIconForService(tituloFinal)}</div>
                                <h2 style={{ color: '#1a1a1a', margin: 0, fontSize: '2.2em', letterSpacing: '1px', textTransform: 'uppercase', fontWeight: '900' }}>
                                    {tituloFinal}
                                </h2>
                            </div>
                            
                            {/* Separador elegante dorado */}
                            <div style={{ width: '60px', height: '3px', backgroundColor: '#B8A066', margin: '0 auto 25px auto' }}></div>
                            
                            <p style={{ color: '#444', lineHeight: '1.8', fontSize: '1.25em', fontStyle: 'italic', maxWidth: '700px', margin: '0 auto' }}>
                                {descripcionFinal || `Nuestro servicio de ${tituloFinal} se rige por los más altos estándares de calidad, respeto y atención personalizada.`}
                            </p>

                            {/* Botón de salida */}
                            <button 
                                onClick={() => setServicioAbierto(null)}
                                style={{ 
                                    marginTop: '35px', padding: '12px 50px', backgroundColor: colorMarca, 
                                    color: 'white', border: 'none', borderRadius: '30px', 
                                    fontWeight: 'bold', cursor: 'pointer', letterSpacing: '1px',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                                onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                            >
                                VOLVER AL PORTAL
                            </button>
                        </div>
                    </div>
                );
            })()}
        </div>
    </div>
)}
{/* 📱 BLOQUE DE RESPONSIVIDAD GLOBAL (SaaS Professional) */}
<style>{`
    /* 1. SCROLLBAR ELEGANTE */
    .custom-scroll::-webkit-scrollbar { width: 6px; }
    .custom-scroll::-webkit-scrollbar-track { background: transparent; }
    .custom-scroll::-webkit-scrollbar-thumb { background: #d4d0c5; border-radius: 10px; }

    /* 2. 🚨 REGLAS PARA MÓVIL (Pantallas menores a 768px) */
    @media (max-width: 768px) {
        /* El contenedor principal deja de ser fijo y permite scroll normal */
        .App-Container-Funeraria { 
            height: auto !important; 
            overflow-y: auto !important; 
        }

        /* El Header azul se pone en vertical para que nada choque */
        header { 
            flex-direction: column !important; 
            padding: 20px !important; 
            gap: 20px;
            text-align: center;
        }

        /* Forzamos que los contenedores internos del header también se apilen */
        header > div { 
            flex-direction: column !important; 
            align-items: center !important; 
            gap: 15px !important;
        }

        /* Las 3 columnas se convierten en 1 sola fila ancha */
        .Main-Grid-Funeraria { 
            grid-template-columns: 1fr !important; 
            height: auto !important;
            overflow: visible !important;
            padding: 15px !important;
            display: flex !important;
            flex-direction: column !important;
        }

        /* El Hero central baja su altura */
        .Hero-Container { 
            height: 300px !important; 
            width: 100% !important;
            order: -1; /* Lo pone arriba del todo */
        }

        /* Las cuadrículas de servicios y homenajes */
        .custom-scroll { 
            overflow-y: visible !important; 
            grid-template-columns: 1fr 1fr !important; 
        }
    }
`}</style>

</div>
       
    );
}

export default PerfilFuneraria;